/**
 * Sets the writing mode for both SSR and CSR environments.
 * @param writingMode - The writing mode (e.g., 'ltr' or 'rtl').
 * @param ssrHtml - Optional: An SSR-generated HTML string to modify.
 * @returns Modified SSR HTML string (if provided) or void.
 */
const setWritingMode = (writingMode, ssrHtml) => {
    if (ssrHtml !== undefined) {
        return ssrHtml.replace(/<html([^>]*)\sdir="[^"]*"([^>]*)>|<html([^>]*)>/, (_, attrs1, attrs2, attrs3) => `<html${(attrs1 || attrs3 || '') + (attrs2 || '')} dir="${writingMode}">`);
    }
    if (typeof document !== 'undefined') {
        document.documentElement.dir = writingMode;
    }
};

export { setWritingMode };
